<template>
    <div>
        <v-list-item @click="lectureAction()" v-ripple="phoneOnly" three-line class="lecture-list-item" :class="{'px-6': phoneOnly, 'px-0': pcOnly, 'appbg': lecture.expired && phoneOnly}" :disabled="locked" :style="locked ? `opacity: 0.5` : ''">
            <div
                v-if="lecture.image_url"
                class="lecture-list-item__thumb my-2"
                :class="{ 'lecture-list-item__thumb--seen': lecture.seen }"
            >
                <v-img
                    :src="lecture.image_url"
                    :alt="lecture.name"
                    contain
                    class="lecture-list-item__thumb-img"
                />
                <v-chip
                    v-if="lecture.seen"
                    color="success"
                    small
                    class="lecture-list-item__seen-badge px-2"
                >
                    <v-icon size="15" color="white">mdi-check-bold</v-icon>
                </v-chip>
            </div>
            <div
                v-else
                class="lecture-list-item__thumb lecture-list-item__thumb--fallback my-2"
                :class="fallbackColorClass"
            >
                <v-progress-circular v-if="loading" color="white" indeterminate :size="23" :width="3" style="opacity: 0.6" />
                <v-icon v-else-if="pay_type === 'course'" color="white" size="36">
                    mdi-{{ lecture.purchased ? 'play-circle' : (lecture.preview ? 'play-speed' : 'play-circle-outline') }}
                </v-icon>
                <v-icon v-else color="white" size="36">
                    mdi-{{ lecture.purchased ? 'motion-play' : 'clipboard-play-outline' }}
                </v-icon>
            </div>
            <v-list-item-content class="align-self-start" style="padding: 12px 0!important;">
                <v-list-item-title class="strong-text--text mb-0" style="line-height: 1.3!important;">{{lecture.name}}</v-list-item-title>
                <v-list-item-subtitle v-if="lecture.description">
                    <div style="line-height: 1.5;" class="details-text text--text">{{lecture.description}}</div>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="pay_type === 'course'" class="strong-text--text details-text mt-2">
                    <span v-if="lecture.expired" class="error--text">منتهية الصلاحية</span>
                    <span v-else-if="lecture.purchased">اضغط لعرض محتويات المحاضرة</span>
                    <span v-else-if="lecture.preview">اضغط لمعاينة المحاضرة</span>
                    <span v-else>احصل على الدورة لعرض المحاضرة</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else class="strong-text--text details-text mt-2">
                    <template v-if="!lecture.purchased">
                        <span v-if="free">احصل عليها اﻵن</span>
                        <span v-else>{{moneyFormat(lecture.price, true)}}</span>
                    </template>
                    <div v-else class="d-flex">
                        <span class="details-text strong-text--text">
                            <span v-if="lecture.expired" class="error--text">منتهية الصلاحية</span>
                            <span v-else-if="free">اضغط لعرض المحاضرة</span> 
                            <span v-else>تم الشراء</span> 
                            <template v-if="lecture.repurchasable">
                                | 
                                <v-btn color="strong-text" text small class="px-1" style="height: auto" @click.stop="purchaseDialog=true" @touchstart.stop @mousedown.stop>
                                    {{free ? 'احصل عليها ' : 'شراء '}}
                                     مرة أخرى؟
                                </v-btn>
                            </template>
                        </span>
                    </div>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon v-if="free && !lecture.purchased">
                <v-icon v-if="pay_type === 'course'" :color="lecture.preview && !lecture.purchased ? 'deep-purple accent-4' : ''">mdi-{{locked ? 'shield-lock-outline' : (lecture.preview && !lecture.purchased ? 'shield-lock-open-outline' : 'chevron-left')}}</v-icon>
                <v-icon v-else :color="free ? 'deep-purple accent-4' : ''">mdi-{{lecture.purchased ? 'chevron-left' : (free ? 'star-four-points-outline' : 'credit-card-plus-outline')}}</v-icon>
            </v-list-item-icon>
        </v-list-item>
        <div style="height: 1px;">
            <v-progress-linear v-if="loading" :active="loading" indeterminate height="1" color="primary"></v-progress-linear>
        </div>
        
        <lecture-purchase-dialog v-if="pay_type !== 'course'" v-model="purchaseDialog" :lecture="lecture" :free="free" @purchased="sync" />

        <lecture-dialog v-if="hasAccess && videosDialog" v-model="videosDialog" :pay_type="pay_type" :lecture="lecture" :items="items" :videos="videos" :exams="exams" :attachments="attachments" />
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import LecturePurchaseDialog from '@/components/custom/lecture-purchase-dialog'
import LectureDialog from '@/components/custom/lecture-dialog'

export default {
    props: {
        lecture: {},
        pay_type: {},
    },
    components: {LecturePurchaseDialog, LectureDialog},
    data(){
        return {
            purchaseDialog: false,
            videosDialog: false,

            items: null,
            videos: null,
            exams: null,
            attachments: null,
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        free(){
            return this.lecture.free || this.lecture.price === 0;
        },
        locked(){
            return this.pay_type === 'course' && !this.lecture.preview && !this.lecture.purchased;
        },
        hasAccess(){
            if (this.pay_type === 'course'){
                return this.lecture.purchased || this.lecture.preview;
            }else{
                return this.lecture.purchased;
            }
        },
        color(){
            let color = '';
            if (this.pay_type === 'course'){
                color = this.locked ? 'strong-text' : (this.lecture.preview ? 'deep-purple accent-4' : 'primary');
            }else{
                color = this.lecture.purchased ? 'secondary' : 'primary';
            }
            return color;
        },
        fallbackColorClass() {
            return this.color.split(/\s+/).filter(Boolean);
        },
    },
    methods: {
        ...GlobalMethods,
        sync(lecture){
            this.$emit('sync', lecture);
        },
        lectureAction(){
            const lecture = this.lecture;
            if (this.hasAccess){
                if (this.appData.lectures_view_layout === 'seperated'){
                    this.$router.push({name: 'lecture', params: {id: lecture.id}})
                }else{
                    this.showVideos();
                }
            }else{
                this.purchaseDialog = true;
            }
        },
        showVideos(){
            this.loadLectureContents();
        },
        loadLectureContents(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/lectures/${this.lecture.id}/contents`).then(response=>{
                    this.loading = false;
                    this.videos = response.data.videos;
                    this.items = response.data.items;
                    this.exams = response.data.exams;
                    this.attachments = response.data.attachments;
                    this.videosDialog = true;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء جلب الفيديوهات', 'error');
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.lecture-list-item {
    align-items: flex-start !important;
}

.lecture-list-item__thumb {
    position: relative;
    flex: 0 0 auto;
    width: clamp(9.5rem, 38vw, 14.5rem);
    aspect-ratio: 16 / 9;
    margin-inline-end: 0.75rem;
    border-radius: 0.5rem;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.04);
    align-self: center;

    @media (min-width: 960px) {
        width: clamp(12rem, 18vw, 17.5rem);
        margin-inline-end: 1rem;
    }
}

.lecture-list-item__thumb--seen {
    .lecture-list-item__thumb-img {
        opacity: 0.75;
    }
}

.lecture-list-item__thumb--fallback {
    display: flex;
    align-items: center;
    justify-content: center;
}

.lecture-list-item__thumb-img {
    width: 100%;
    height: 100%;
}

.lecture-list-item__seen-badge {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.course-card.v-card {
    transition: 0.1s ease all;
    border-radius: 6px !important;
    overflow: hidden;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.1) !important;
}
</style>